export const INVITE_AGENT_START = 'INVITE_AGENT_START';
export const INVITE_AGENT_SUCCESS = 'INVITE_AGENT_SUCCESS';
export const INVITE_AGENT_ERROR = 'INVITE_AGENT_ERROR';
